module.exports = __webpack_public_path__ + "static/jeff-9f4a345c2b0d9fdff42cc543660a84fb.png";